const topics = [
  { name: '院线热映', icon: 'ri-film-line', heat: '🔥 2.3万讨论', color: 'bg-primary-50 text-primary-700' },
  { name: '科幻大片', icon: 'ri-rocket-2-line', heat: '🔥 1.8万讨论', color: 'bg-accent-50 text-accent-700' },
  { name: '国产佳片', icon: 'ri-flag-2-line', heat: '1.6万讨论', color: 'bg-secondary-50 text-secondary-700' },
  { name: '悬疑惊悚', icon: 'ri-ghost-line', heat: '1.3万讨论', color: 'bg-primary-50 text-primary-700' },
  { name: '动画电影', icon: 'ri-palette-line', heat: '1.2万讨论', color: 'bg-accent-50 text-accent-700' },
  { name: '经典重温', icon: 'ri-vip-crown-line', heat: '9800讨论', color: 'bg-secondary-50 text-secondary-700' },
  { name: '韩国电影', icon: 'ri-earth-line', heat: '8700讨论', color: 'bg-primary-50 text-primary-700' },
  { name: '爱情文艺', icon: 'ri-heart-2-line', heat: '7600讨论', color: 'bg-accent-50 text-accent-700' },
  { name: '纪录片', icon: 'ri-camera-lens-line', heat: '6500讨论', color: 'bg-secondary-50 text-secondary-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              话题标签
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              最热电影话题讨论，找到志同道合的影迷
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic, i) => (
              <a
                key={i}
                href="#topics"
                onClick={(e) => e.preventDefault()}
                className={`group inline-flex items-center gap-2.5 px-5 py-3 rounded-full ${topic.color} hover:opacity-80 transition-opacity cursor-pointer`}
              >
                <i className={`${topic.icon} text-sm`}></i>
                <span className="text-sm font-semibold whitespace-nowrap">{topic.name}</span>
                <span className="text-xs opacity-70">{topic.heat}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}